import { createFileRoute } from "@tanstack/react-router";
import ArticleGenerator from "@/components/stealth-writer/GenerateArticle";
import { ArticleFormProvider } from "@/components/stealth-writer/GenerateArticle/ArticleFormContext";

export const Route = createFileRoute(
  "/_app/stealth-ai-writer/generate-article",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ArticleFormProvider>
      <ArticleGenerator />
    </ArticleFormProvider>
  );
}
